//#region DevExtreme Imports

import 'devextreme/ui/scroll_view'

//#endregion

//#region Asset Imports

import './datatype-legend.directive.scss'
import * as TEMPLATE from './datatype-legend.directive.tpl.html'

//#endregion

interface DatatypeLegendInterface extends ng.IScope {
    data: {
        rects: {
            color: string
            description: string
        }[]
        icons: {
            imgSrc: string
            description: string
        }[]
    }
}

export class DatatypeLegendDirective implements ng.IDirective {
    constructor() { }

    scope = {
        data: '='
    }
    restrict = 'E'
    controller = ['$scope', ($scope: DatatypeLegendInterface) => {
        //$scope.data.rects.push(...$scope.data.rects, ...$scope.data.rects)
        //$scope.data.rects.push(...$scope.data.rects, ...$scope.data.rects)
    }]
    template = TEMPLATE
    transclude = true
}